module.exports = __webpack_public_path__ + "static/media/InvitationCode_viejo.08c48546.svg";